var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidetoggleswapGra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.138,
    height: 100.191,
    viewBox: "715.302 408.492 24.784 25.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Side.toggle.swap-graphic"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": ".target-image"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPowerTripleIcon",
    transform: "translate(714.627 408.4)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPowerTriple"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u5408\\u4F53 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.496 24.976c-.024-.054-.035-.074-.036-.086 0-.015.017-.018.048-.063l1.09-.739 4.046-9.225-.15-1.085-4.696-3.54a5.291 5.291 0 01-1.579 1.415h-3.505l-.13 2.839.067 7.575-.055.58c.507.423.864 1.331.864 1.659 0 .434-.624.785-1.393.785-.77 0-1.393-.351-1.393-.785 0-.326.353-1.226.856-1.651l-.055-.588.074-7.575-.13-2.84H8.916a5.292 5.292 0 01-1.579-1.414l-4.697 3.54-.15 1.085 4.047 9.225 1.09.739c.03.045.048.048.048.063 0 .012-.012.032-.036.086-.064.143-.177.203-.253.135l-2.572-.845L.675 15.11l.402-2.385 5.376-4.08a8.299 8.299 0 01-.562-3.02c0-2.25 1.087-4.25 2.77-5.534h8.813c1.682 1.285 2.77 3.283 2.769 5.533 0 1.036-.19 2.078-.562 3.02l5.376 4.081.402 2.385-4.138 9.156-2.572.845a.104.104 0 01-.07.028c-.065 0-.137-.06-.183-.163zM13.067 9.72a4.025 4.025 0 004.02-4.02 4.025 4.025 0 00-4.02-4.02 4.025 4.025 0 00-4.02 4.02 4.025 4.025 0 004.02 4.02zM9.772 5.7a3.299 3.299 0 013.295-3.295A3.299 3.299 0 0116.362 5.7a3.299 3.299 0 01-3.295 3.295A3.299 3.299 0 019.772 5.7z",
    fill: "#b3b3b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.496 24.976c-.024-.054-.035-.074-.036-.086 0-.015.017-.018.048-.063l1.09-.739 4.046-9.225-.15-1.085-4.696-3.54a5.291 5.291 0 01-1.579 1.415h-3.505l-.13 2.839.067 7.575h0l-.055.58c.507.423.864 1.331.864 1.659 0 .434-.624.785-1.393.785-.77 0-1.393-.351-1.393-.785 0-.326.353-1.226.856-1.651l-.055-.588.074-7.575-.13-2.84H8.916a5.292 5.292 0 01-1.579-1.414l-4.697 3.54-.15 1.085 4.047 9.225 1.09.739c.03.045.048.048.048.063 0 .012-.012.032-.036.086-.064.143-.177.203-.253.135l-2.572-.845L.675 15.11l.402-2.385 5.376-4.08a8.299 8.299 0 01-.562-3.02c0-2.25 1.087-4.25 2.77-5.534h8.813c1.682 1.285 2.77 3.283 2.769 5.533 0 1.036-.19 2.078-.562 3.02l5.376 4.081.402 2.385-4.138 9.156-2.572.845a.104.104 0 01-.07.028c-.065 0-.137-.06-.183-.163zM13.067 9.72a4.025 4.025 0 004.02-4.02 4.025 4.025 0 00-4.02-4.02 4.025 4.025 0 00-4.02 4.02 4.025 4.025 0 004.02 4.02zM9.772 5.7a3.299 3.299 0 013.295-3.295A3.299 3.299 0 0116.362 5.7a3.299 3.299 0 01-3.295 3.295A3.299 3.299 0 019.772 5.7z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "rgba(0,0,0,0 )",
    fill: "transparent"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "side_toggle_swap-gra_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h26v26H0V0z",
    "data-name": "\\u9577\\u65B9\\u5F62 686"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "side_toggle_swap-gra_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h26v26H0V0z",
    "data-name": "\\u9577\\u65B9\\u5F62 687"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidetoggleswapGra);
export default __webpack_public_path__ + "static/media/side.toggle.swap-gra.fcf646b8ffbe6cd5.svg";
export { ForwardRef as ReactComponent };